import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import moment from 'moment';
export default {
  name: 'monitor',
  data: function data() {
    var _this = this;

    return {
      options: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      limitSelectDate: {},
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        align: 'center',
        sorter: true
      },
      queryParam: {},
      dataSource: [],
      columns: [],
      allColumns: [],
      selectCol: [],
      cols: [{
        title: '监测时间',
        align: 'center',
        width: 150,
        dataIndex: 'dateStr',
        colName: 'data_time'
      }, {
        title: '水质标准',
        align: 'center',
        width: 100,
        dataIndex: 'status',
        customRender: function customRender(text, record, index) {
          return _this.renderStatus(record);
        }
      }],
      loading: false
    };
  },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.id = ids[1];
        this.queryParam.type = '1';
        this.loadData();
      } else {
        this.queryParam.id = ids[1];
        this.queryParam.type = '2';
        this.loadData();
      }
    }
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  methods: {
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function spliceColumn(col, idx) {
      //debugger
      var tempColumn = this.columns.filter(function (item) {
        return item.dataIndex != col.dataIndex;
      }); //不允许存在dataIndex相同的列

      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col);
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn;
        }
      }
    },
    // 查询
    searchQuery: function searchQuery() {
      this.loadData();
    },
    // 列变化
    onChange: function onChange(checkedValues) {
      var _this2 = this;

      this.columns = _toConsumableArray(this.cols);
      checkedValues.forEach(function (item, i) {
        _this2.allColumns.forEach(function (element) {
          if (item == element.id) {
            _this2.columns.push(element);
          }
        });
      });
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    },
    // 水质标准
    renderStatus: function renderStatus(record) {
      var h = this.$createElement;

      if (record.currentStandard) {
        return h("span", {
          "class": "statusText",
          "style": 'background-color:' + record.currentStandard.color
        }, [record.currentStandard.title]);
      } else {
        return '';
      }
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    // 加载表格
    loadData: function loadData(once) {
      var _this3 = this;

      this.loading = true;
      var that = this;
      getAction('/st21/cn2061', this.queryParam).then(function (res) {
        if (res.success) {
          that.dataSource = res.result.records;
          that.allColumns = _toConsumableArray(that.cols);
          that.selectCol = [];
          that.options = [];
          res.result.factors.forEach(function (element) {
            that.options.push({
              label: element.title,
              value: element.id
            });
            that.selectCol.push(element.id);
            that.allColumns.push({
              id: element.id,
              title: element.title,
              align: 'center',
              width: 250,
              children: [{
                title: element.unitName,
                align: 'center',
                width: 200,
                dataIndex: element.code,
                customRender: function customRender(text, record, index) {
                  return that.renderCol(element.id, text, record);
                }
              }]
            });
          });
          that.columns = _toConsumableArray(that.allColumns);

          if (that.queryParam.type == '1') {
            that.spliceColumn(that.siteColumn);
          } else if (that.queryParam.type == '2') {
            that.spliceColumn(that.siteColumn, 1);
          }
        } else {
          _this3.$message.warning('系统异常=>' + res.message);
        }

        _this3.loading = false;
      });
    }
  }
};